exports = module.exports = require("../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".customer-passport-valid-text{margin-right:2.95rem}body[dir=rtl] .customer-passport-valid-text {\n  margin-left: 2.95rem;\n}\n", ""]);

// exports
